import {useSsoStore} from "@/store/modules/sso.store";

export default {
    path: "/consulta",
    name: "Consulta",
    meta: {
        title: "Consulta",
    },
    children: [
        {
            path: "/dorian",
            name: "ListadoConsulta",
            component: () => import(/* webpackPrefetch: true */"@/views/modules/medical/tables/Consulta"),

        },
    ]
}